import { defineStore } from 'pinia'

export const useAppearanceStore = defineStore('appearance', {
    state: () => ({
        isNotificationOpen: false,
        notificationMessage: '',
        notificationType: '', // danger, warning, success
        scroll: 0,
        scrollChild: null,
        hasReload: false,
        isPersistentNotification: false,
        forceUpdate: false,
        isMainMenuOpen: false,
    }),
    actions: {
        setNotification({ value, message, type, hasReload, isPersistentNotification, forceUpdate }) {
            this.isNotificationOpen = value
            this.notificationMessage = message
            this.notificationType = type
            this.hasReload = hasReload
            this.isPersistentNotification = isPersistentNotification
            this.forceUpdate = forceUpdate
        },

        setScroll(value) {
            this.scroll = value
        },

        setScrollChild(element) {
            this.scrollChild = element
        },

        setMainMenu(value) {
            this.isMainMenuOpen = value
        },

        handleNotification({ message, type, hasReload, isPersistentNotification, forceUpdate }) {
            this.setNotification({
                value: true,
                message,
                type,
                hasReload,
                isPersistentNotification,
                forceUpdate,
            })
        },

        closeNotification() {
            this.setNotification({ value: false, message: '', type: '' })
        },

        toggleMainMenu() {
            this.setMainMenu(!this.isMainMenuOpen)
        },

        closeMainMenu() {
            this.setMainMenu(false)
        },
    },
})
